import React, { useRef, useEffect, useState } from 'react';

const RegNoModal = ({
  isOpen,
  onClose,
  onOK,
  elevator,
}) => {
  const textRef = useRef(null);
  const [isMultiLine, setIsMultiLine] = useState(false);

  useEffect(() => {
    if (isOpen && textRef.current) {
      const lineHeight = parseFloat(window.getComputedStyle(textRef.current).lineHeight);
      const height = textRef.current.clientHeight;
      setIsMultiLine(height > lineHeight * 1.5);
    }
  }, [isOpen]);

  const handleModalClose = () => {
    onClose();
  };

  const handleModalOK = () => {
    onOK();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-[80] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-xs mx-auto transform transition-all duration-300 ease-out">
        <div className="p-6 text-center relative">
          <button
            onClick={handleModalClose}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div className="w-12 h-12 mx-auto mb-4 flex justify-center items-center select-none">
            <img src="./assets/static/MEL_5.png" className="h-6 w-6" alt="infoアイコン" />
          </div>

          <h3 className="text-lg font-bold text-gray-800 select-none">登録番号の確認</h3>
          <p
            ref={textRef}
            className={`select-none text-sm text-gray-600 mt-2 ${isMultiLine ? 'text-left' : 'text-center'}`}
          >
            このエレベータの登録番号は下記です。
          </p>
          <input type="text" readOnly value={elevator ? elevator.regNumber : ''} className="mt-4 w-full px-4 py-2 border border-gray-300 rounded-lg text-center text-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <button
            onClick={handleModalOK}
            className="mt-12 w-full ux-bg-dark-gray text-white font-bold py-2 px-4 rounded-lg active:bg-gray-700 transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegNoModal;